import { NgModule } from '@angular/core';
import { KbComponent } from './kb.component';
import { Routes, RouterModule } from '@angular/router';
import { DDStaffAuthGuard } from '../admin/admin.authguard';

const routes: Routes = [
  { 
    path: 'kb', 
    component: KbComponent,
    canActivate: [DDStaffAuthGuard]
  },
  { 
    path: 'kb/:id', 
    component: KbComponent,
    canActivate: [DDStaffAuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KbRoutingModule { }